/**
 * Terms Page Component
 * Renders the Terms of Service document outlining acceptable website usage,
 * booking agreements, liability disclaimers, and contact terms for the Trust.
 */

import React, { useEffect, useState } from 'react';
import { getSiteContent } from '../utils/siteContent';

const Terms = () => {
  const [siteContent, setSiteContent] = useState(() => getSiteContent());

  useEffect(() => {
    const handleContentUpdate = () => setSiteContent(getSiteContent());
    window.addEventListener('site-content-updated', handleContentUpdate);
    return () => window.removeEventListener('site-content-updated', handleContentUpdate);
  }, []);

  return (
    <div className="content-page-container" style={styles.container}>
      <h1 id="terms-page-heading" style={styles.title}>Terms of Service</h1>
      <div style={styles.content}>
        <p>{siteContent.terms.intro}</p>

        <h2 style={styles.sectionTitle}>What you are allowed to do</h2>
        <ul style={styles.list}>
          {siteContent.terms.allowed.map((item) => <li key={item}>{item}</li>)}
        </ul>

        <h2 style={styles.sectionTitle}>What you are not allowed to do</h2>
        <ul style={styles.list}>
          {siteContent.terms.disallowed.map((item) => <li key={item}>{item}</li>)}
        </ul>

        <h2 style={styles.sectionTitle}>User responsibilities</h2>
        <ul style={styles.list}>
          {siteContent.terms.responsibilities.map((item) => <li key={item}>{item}</li>)}
        </ul>

        <h2 id="terms-rules-section" style={styles.sectionTitle}>Website rules</h2>
        <ul style={styles.list}>
          {siteContent.terms.rules.map((item) => <li key={item}>{item}</li>)}
        </ul>

        <h2 style={styles.sectionTitle}>Legal notice</h2>
        <p style={styles.paragraph}>{siteContent.terms.legal}</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '60px 20px',
    maxWidth: '900px',
    margin: '0 auto',
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif'
  },
  title: {
    fontSize: '36px',
    color: '#1f2937',
    marginBottom: '24px',
    textAlign: 'center'
  },
  content: {
    fontSize: '18px',
    lineHeight: '1.8',
    color: '#4b5563'
  },
  sectionTitle: {
    marginTop: '28px',
    marginBottom: '14px',
    fontSize: '24px',
    color: '#0f4b2f'
  },
  list: {
    marginLeft: '1.1rem',
    marginBottom: '16px',
    paddingLeft: '18px'
  },
  paragraph: {
    marginTop: '16px',
    marginBottom: '16px'
  }
};

export default Terms;
